var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-page"},[_c('iframe',{ref:"iframe",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.jgIp + _vm.src,"frameborder":"0"},on:{"load":_vm.loaded}})])
}
var staticRenderFns = []

export { render, staticRenderFns }